module.exports = __webpack_public_path__ + "static/media/alert-message-received.070e376c.mp3";